module.exports = __webpack_public_path__ + "img/comp-42.e868cc3a.png";